import script from "./SubscriptionPlanDescription.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionPlanDescription.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlanDescription.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionPlanDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanDescription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8591dc4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8591dc4c', __exports__)) {
    api.reload('8591dc4c', __exports__)
  }
  
}


export default __exports__